<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
      }"
      v-on:input="formData = $event"
      v-on:cancel="cancelHandler"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ReviewExerciseForm from "../../../components/performance/reviewexercise/Form_Item";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ReviewExerciseForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      id: this.$route.params.id, //id for reviewer in pmreviewstaffreviewer
      pageTitle: this.$t('pmreviewexercise.editappraisalrecordfor'),
      pageTitleValue: this.$route.params.staffData.staffcode + " - " + this.$route.params.staffData.staffname,

      formData: {
        id: this.$route.params.id,
        pmreviewexerciseid: this.$route.params.staffData.pmreviewexerciseid,
        pmreviewexercisedid: this.$route.params.pmreviewexercisedid,
        pmrankmapsetid: this.$route.params.staffData.pmrankmapsetid,
        reviewcode: this.$route.params.staffData.reviewcode,
        description: this.$route.params.staffData.description,
        assessmentcode: this.$route.params.staffData.assessmentcode,
        startdate: this.$route.params.staffData.startdate,
        enddate: this.$route.params.staffData.enddate,
        formtype: this.$route.params.staffData.formtype,
        type: this.$route.params.staffData.type,
        staffid: this.$route.params.staffData.staffid,
        staffname: this.$route.params.staffData.staffname,
        staffcode: this.$route.params.staffData.staffcode,
        staffcompany : this.$route.params.staffData.staffcompany,
        initiated: this.$route.params.staffData.initiated,
        ongoing: this.$route.params.staffData.ongoing,
        completed: this.$route.params.staffData.completed,
        totalRecords: this.$route.params.staffData.totalRecords,
        reviewerid: this.$route.params.item.reviewerid,
        reviewername: this.$route.params.item.staffname,
        reviewercode: this.$route.params.item.staffcode,
        reviewercompany : this.$route.params.item.compnyname,
        reviewertype: this.$route.params.item.reviewertypename,
        reviewfromdate: this.$route.params.item.reviewfromdate,
        reviewuntildate: this.$route.params.item.reviewuntildate,
        pmreviewformid : this.$route.params.item.reviewformid,
        method: this.$route.params.method,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

  },

  mounted() {
  },
};
</script>